<template>
    <rkm-modal
        extraLarge
        ref="Modal"
        title="Texto pronto"
    >

        <Form
            :data="data"
            :index="index"
            @save="handleExit"
            ref="Form"
        />

        <template v-slot:footer="{ cancel }">
            <rkm-button @click="cancel">
                Fechar
            </rkm-button>
        </template>
    </rkm-modal>
</template>

<script>
// Components.
import Form from './Form'

export default {
    components: { Form },
    data: () => ({
        index: null
    }),
    methods: {
        open(index) {

            this.index = index

            this.$refs.Modal.show()
        },
        handleExit(data) {

            this.$emit('save', data)
        },
    },
    props: {
        data: { type: Object, required: true },
    }
}
</script>